import { jsonataWithCallback } from '../../../../modules/expressions';
import { logger } from '../../../../utils';

// NOTE: The logic implemented below originates from DASHUI-4742.

/**
 * Processes a given value using an optional processing function.
 * If no processing function is provided, the original value is returned.
 *
 * @param value - The value to be processed.
 * @param processorFunc - An optional processing function containing arguments and a body.
 * @returns The processed value if a processor function is provided; otherwise, the original value.
 */
export const getProcessedValue = async (value: unknown, processorFunc?: string): Promise<unknown> => {
  // If a processor function is provided, create and execute it
  if (processorFunc) {
    // Evaluate the jsonata function with the given value
    const executeExpression = async () => {
      const jsonataExpression = '($processFunc := $eval($.processorFunc); $processFunc($.value))';
      try {
        const out = await jsonataWithCallback(jsonataExpression, {
          processorFunc,
          value,
        });
        logger.log('Evaluating', jsonataExpression, value, out);
        return out;
      } catch (error) {
        logger.error('Error evaluating', jsonataExpression, processorFunc, value, error);
      }
    };
    return await executeExpression();
  }

  // If no processor function is provided, return the original value
  return value;
};
